import React from 'react'
import Dashboard from '../dashboard'
import PaymentsView from './page'

const Payments = () => {
  return <Dashboard component={<PaymentsView />} />
}

export default Payments
